import { MediaAdapterSubs } from "./MediaAdapter";
import { Subscription } from "../libs/listeners/Subscription";
export class YouTubeMediaAdapter {
    constructor() {
        this.name = 'YouTubeMediaAdapter';
        this.shortName = 'YMA';
        this.listener = new Subscription();
        this._state = 'not_started';
        this._apiScript = null;
        this.onStateChange = (event) => {
            switch (event.data) {
                case window.YT.PlayerState.ENDED:
                    this._state = 'ended';
                    this.listener.inform(MediaAdapterSubs.onStateChange);
                    break;
                case window.YT.PlayerState.PLAYING:
                    this._state = 'playing';
                    this.listener.inform(MediaAdapterSubs.onStateChange);
                    break;
                case window.YT.PlayerState.PAUSED:
                    this._state = 'paused';
                    this.listener.inform(MediaAdapterSubs.onStateChange);
                    break;
                case window.YT.PlayerState.BUFFERING:
                    break;
                case window.YT.PlayerState.CUED:
                    break;
            }
        };
    }
    init(params) {
        if (!this._apiScript) {
            this._apiScript = document.createElement('script');
            this._apiScript.id = 'script_youtube';
            this._apiScript.src = "https://www.youtube.com/iframe_api";
            const firstScriptTag = document.getElementsByTagName('script')[0];
            firstScriptTag.parentNode.insertBefore(this._apiScript, firstScriptTag);
        }
        this._params = params;
    }
    appendTo(playerHtml, autoPlay = false) {
        this._playerHtml = playerHtml;
        this.onReady().then(() => {
            this._player = new window.YT.Player(playerHtml, {
                playerVars: { 'autoplay': autoPlay ? 1 : 0, "rel": 0 },
                videoId: this._params.ref,
                events: {
                    onStateChange: this.onStateChange,
                    onError: this.onPlayerError
                }
            });
        });
    }
    onPlayerError(event) {
        this._state = 'error';
    }
    isAttachedToDOM() {
        return this._playerHtml.childNodes.length > 0;
    }
    set currentDuration(seconds) {
        if (this._player) {
            this._player.seekTo(seconds, true);
        }
    }
    get currentDuration() {
        if (this._player) {
            this._player.getCurrentTime();
        }
        return -1;
    }
    get totalDuration() {
        if (this._player) {
            this._player.getDuration();
        }
        return -1;
    }
    play() {
        if (this._player) {
            this._player.playVideo();
        }
    }
    stop() {
        if (this._player) {
            this._player.stopVideo();
        }
    }
    get currentState() {
        return this._state;
    }
    pause() {
        if (this._player) {
            this._player.pauseVideo();
        }
    }
    onReady() {
        if (this._onReady) {
            return this._onReady;
        }
        return this._onReady = new Promise((resolve, reject) => {
            window.onYouTubeIframeAPIReady = function () {
                resolve();
            };
        });
    }
    destroy() {
        if (this._player) {
            this._player.destroy();
            this._player = null;
        }
    }
}
